import PeopleScene from "./PeopleScene"
import "./styles.css"

export function People() {
  return <PeopleScene />
}

export default People
